import Swal from 'sweetalert2';
import * as actionTypes from "../action-types";
import { put, call, takeLeading, select } from 'redux-saga/effects';
import SocketService from '../../utils/services/socket-service';
import { getAPI, postAPI } from '../../utils/api-function';
import { toaster } from '../../utils/services/toast-service';
import { Color } from '../../assets/colors';

function* getCurrentConsultationSessionData() {
    try {
        const { data } = yield postAPI('api/astrologer/get_consultation-booking-by-id', { consultationId: localStorage.getItem('consultationId') });
        console.log("Get Puja Data Saga Response ::: ", data);

        if (data?.success) {
            yield put({ type: actionTypes.SET_CURRENT_CONSULTATION_SESSION_DATA, payload: data?.pooja })
        }

    } catch (error) {
    }
};

function* joinConsultationSessionByAstrologer(action) {
    try {
        const { payload } = action;
        console.log("joinConsultationSessionByAstrologer Payload ::: ", payload);

        switch (payload?.consultation_type) {
            case 'chat':
                SocketService?.emit('create-consultation-room', {
                    total_time_duration: payload?.data?.slotId?.duration * 60,
                    astrologerId: payload?.data?.astrologerId,
                    customerId: payload?.data?.customerId?._id,
                    consultationId: payload?.data?._id,
                });
                SocketService.emit('join-consultation-room', { consultationId: payload?.data?._id, astrologerId: payload?.data?.astrologerId });
                localStorage.setItem('consultationId', payload?.data?._id);

                yield call(payload?.onComplete);
                return;

            case 'videocall':
                const { data } = yield getAPI(`api/zoom/listMeetingsById/${payload?.data?.meetingId}`);
                console.log("Videocall Data :::", data);

                if (data?.status) {
                    // yield call(payload?.onVideocallComplete, { meeting_number: data?.data?.id, password: data?.data?.password, signature: data?.signature })
                    window.open(data?.data?.join_url);
                }
                return;

            case 'call':
                console.log("Initiating Voice Call!!!");
                console.log({ astrologerId: payload?.data?.astrologerId, customerId: payload?.data?.customerId?._id, formId: payload?.data?._id, maxDuration: payload?.data?.slotId?.duration * 60, consultationId: payload?.data?._id });
                const { data: send_call_request } = yield postAPI('api/customers/initiate_call_with_exotel', { astrologerId: payload?.data?.astrologerId, customerId: payload?.data?.customerId?._id, formId: payload?.data?._id, maxDuration: payload?.data?.slotId?.duration * 60, consultationId: payload?.data?._id });
                console.log('send_call_request', send_call_request);

                if (send_call_request?.success) {
                    toaster.success({ text: "Call request send successfully!!!" });
                } else {
                    toaster.info({ text: send_call_request?.message });
                }
                return;

            default:
                return;
        }

    } catch (error) {
        // toaster.error({ text: 'Failed to join session' })
        toaster.error({ text: error?.response?.data?.message || 'Failed to join session' })
        console.log("joinConsultationSessionByAstrologer Saga Error ::: ", error);
    }
};

function* joinConsultationSessionByCustomer(action) {
    try {
        const { payload } = action;
        console.log("joinConsultationSessionByCustomer Payload ::: ", payload);

        switch (payload?.consultation_type) {
            case 'chat':
                SocketService?.emit('create-consultation-room', {
                    total_time_duration: payload?.data?.slotId?.duration * 60,
                    astrologerId: payload?.data?.astrologerId?._id,
                    customerId: payload?.data?.customerId,
                    consultationId: payload?.data?._id,
                });

                SocketService.emit('join-consultation-room', { consultationId: payload?.data?._id, customerId: payload?.data?.customerId });
                // SocketService.emit('start-consultation-timer', ({ consultationId: payload?.data?._id, customerId: payload?.data?.customerId }));
                localStorage.setItem('consultationId', payload?.data?._id);

                yield call(payload?.onComplete);
                return;

            case 'videocall':
                const { data } = yield getAPI(`api/zoom/listMeetingsById/${payload?.data?.meetingId}`);
                console.log("Videocall Data :::", data);

                if (data?.status) {
                    // yield call(payload?.onVideocallComplete, { meeting_number: data?.data?.id, password: data?.data?.password, signature: data?.signature })
                    window.open(data?.data?.join_url)
                }
                return;

            case 'call':
                console.log("Initiating Voice Call!!!");
                console.log({ astrologerId: payload?.data?.astrologerId?._id, customerId: payload?.data?.customerId, formId: payload?.data?._id, maxDuration: payload?.data?.slotId?.duration * 60, consultationId: payload?.data?._id });
                const { data: send_call_request } = yield postAPI('api/customers/initiate_call_with_exotel', { astrologerId: payload?.data?.astrologerId?._id, customerId: payload?.data?.customerId, formId: payload?.data?._id, maxDuration: payload?.data?.slotId?.duration * 60, consultationId: payload?.data?._id });
                console.log('send_call_request', send_call_request);

                if (send_call_request?.success) {
                    toaster.success({ text: "Call request send successfully!!!" });
                } else {
                    toaster.info({ text: send_call_request?.message });
                }
                return;

            default:
                return;
        }

    } catch (error) {
        // toaster.error({ text: 'Failed to join session' })
        toaster.error({ text: error?.response?.data?.message || 'Failed to join session' })
        console.log("joinConsultationSessionByCustomer Saga Error ::: ", error);
    }
};

function* closeConsultationSession(action) {
    try {
        const { payload } = action;
        console.log("closeConsultationSession Payload ::: ", payload);

        if (payload) {
            console.log("On Complete Run");
            localStorage.removeItem('consultationId');
            yield put({ type: actionTypes.SET_CONSULTATION_TIMER_COUNTDOWN, payload: 0 });
            // window.open('/')
            yield call(payload?.onComplete);
        }

    } catch (error) {
        console.log("closeConsultationSession Saga Error ::: ", error);
    }
};

function* suggestRemediesDuringChat(action) {
    try {
        const { payload } = action;
        console.log('Suggest Remedies During Chat Payload ::: ', payload);

        const result = yield Swal.fire({
            icon: "warning", text: "Do you want to send this remedies?", showConfirmButton: true, timer: 20000,
            confirmButtonText: "Yes", confirmButtonColor: Color.primary, cancelButtonText: "No", showCancelButton: true, cancelButtonColor: Color.darkgrey
        });
        console.log('result', result);

        if (result.isConfirmed) {
            const { data } = yield postAPI('api/puja/add_suggested_remedies', payload?.data);
            console.log("Suggested Puja Response :::", data);

            yield call(payload?.onComplete);
        }
    } catch (error) {
        console.log('Suggest Remedies During Chat Saga Error ::: ', error?.response?.data);
    }
};

export default function* consultationSaga() {
    yield takeLeading(actionTypes?.GET_CURRENT_CONSULTATION_SESSION_DATA, getCurrentConsultationSessionData);
    yield takeLeading(actionTypes?.JOIN_CONSULTATION_SESSION_BY_ASTROLOGER, joinConsultationSessionByAstrologer);
    yield takeLeading(actionTypes?.JOIN_CONSULTATION_SESSION_BY_CUSTOMER, joinConsultationSessionByCustomer);
    yield takeLeading(actionTypes?.CLOSE_CONSULTATION_SESSION, closeConsultationSession);
    yield takeLeading(actionTypes?.SUGGEST_REMEDIES_DURING_CHAT, suggestRemediesDuringChat);
};